<template>
<div class="dn-root" :style="themePageStyle">
  <nav class="dn-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <back-button class="me-2" />
      <a href="javascript:void(0)" @click="$router.push('/dashboard')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Delivery Notes <span v-if="farm.name" style="opacity:.7;font-weight:400;">· {{ farm.name }}</span></span>
    </div>
    <button class="btn btn-sm btn-warning" @click="openCreate"><i class="mdi mdi-plus me-1"></i>New delivery note</button>
  </div></nav>

  <div class="container dn-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!notes.length" class="dn-card text-center" style="padding:40px;">
      <i class="mdi mdi-truck-delivery-outline" style="font-size:48px;color:var(--fm-s,#6B6356);"></i>
      <div style="color:var(--fm-h,#F5F0E8);font-weight:600;margin-top:8px;">No delivery notes yet</div>
      <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:4px;">Create one when shipping animals to a slaughterhouse, market or buyer.</div>
      <button class="btn btn-warning mt-3" @click="openCreate"><i class="mdi mdi-plus me-1"></i>New delivery note</button>
    </div>

    <div v-else>
      <div v-for="n in notes" :key="'dn-'+n.id" class="dn-card mb-2">
        <div class="d-flex justify-content-between align-items-start flex-wrap" style="gap:8px;">
          <div class="flex-fill" style="min-width:0;">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <span class="dn-ref">{{ n.document_ref }}</span>
              <span class="dn-status" :class="'st-'+n.status">{{ statusLabel(n.status) }}</span>
            </div>
            <div style="color:var(--fm-h,#F5F0E8);font-weight:600;margin-top:4px;">{{ n.destination_name }}</div>
            <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:2px;">
              <i class="mdi mdi-calendar me-1"></i>{{ fD(n.delivery_date) }} · <i class="mdi mdi-cow me-1"></i>{{ n.total_animals }} animal{{ n.total_animals===1?'':'s' }}
              <span v-if="n.driver_name"> · <i class="mdi mdi-account me-1"></i>{{ n.driver_name }}</span>
              <span v-if="n.vehicle_reg"> · <i class="mdi mdi-truck me-1"></i>{{ n.vehicle_reg }}</span>
            </div>
            <div v-if="n.prepared_by_name" style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">Prepared by {{ n.prepared_by_name }}</div>
          </div>
          <div class="d-flex gap-1 flex-wrap">
            <button class="btn btn-sm btn-warning" @click="openPrint(n)"><i class="mdi mdi-printer me-1"></i>View / Print</button>
            <button class="btn btn-sm btn-outline-warning" v-if="n.status==='draft'" @click="openEdit(n)"><i class="mdi mdi-pencil"></i></button>
            <button class="btn btn-sm btn-outline-success" v-if="n.status==='draft'" @click="dispatch(n)"><i class="mdi mdi-truck-fast me-1"></i>Dispatch</button>
            <button class="btn btn-sm btn-success" v-if="n.status==='dispatched'" @click="openReceive(n)"><i class="mdi mdi-check-decagram me-1"></i>Mark received</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Create / Edit modal -->
  <div v-if="showForm" class="dn-overlay" @click.self="showForm=false">
    <div class="dn-modal">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h5 class="m-0 fw-bold" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-truck-delivery me-1"></i>{{ form.id ? 'Edit delivery note' : 'New delivery note' }}</h5>
        <button class="btn-close btn-close-white" @click="showForm=false"></button>
      </div>

      <div class="row g-2 mb-2">
        <div class="col-md-8"><label class="dn-label">Destination *</label><input v-model="form.destinationName" class="dn-input w-100" placeholder="e.g. Rumuruti Slaughterhouse" /></div>
        <div class="col-md-4"><label class="dn-label">Delivery date *</label><input v-model="form.deliveryDate" type="date" class="dn-input w-100" :max="todayStr" /></div>
      </div>
      <div class="mb-2"><label class="dn-label">Destination address</label><input v-model="form.destinationAddress" class="dn-input w-100" placeholder="e.g. Ngare Narok, Laikipia" /></div>
      <div class="row g-2 mb-2">
        <div class="col-md-4"><label class="dn-label">Driver name</label><input v-model="form.driverName" class="dn-input w-100" /></div>
        <div class="col-md-4"><label class="dn-label">Vehicle reg</label><input v-model="form.vehicleReg" class="dn-input w-100" placeholder="KCB 123A" /></div>
        <div class="col-md-4"><label class="dn-label">DVS permit no</label><input v-model="form.dvsPermitNo" class="dn-input w-100" /></div>
      </div>
      <div class="row g-2 mb-3">
        <div class="col-md-6"><label class="dn-label">Vet officer name</label><input v-model="form.vetOfficerName" class="dn-input w-100" /></div>
        <div class="col-md-6"><label class="dn-label">Vet DVS permit no</label><input v-model="form.vetDvsPermitNo" class="dn-input w-100" /></div>
      </div>

      <h6 class="fw-bold" style="color:var(--fm-h,#F5F0E8);">Animals — pick from farm or add manually</h6>
      <div class="dn-pick">
        <input v-model="animalFilter" class="dn-input w-100" placeholder="Search ear tag or breed..." />
        <div class="dn-pick-list">
          <label v-for="a in filteredAnimals" :key="'fa-'+a.id" class="dn-pick-row">
            <input type="checkbox" :value="a.id" v-model="form.selectedAnimalIds" @change="onAnimalToggled(a)" />
            <span class="flex-fill"><strong>{{ a.tag_number }}</strong> <span style="color:var(--fm-m,#A09888);">{{ a.breed_name || '' }} · {{ humanize(a.sex || '') }}</span></span>
            <span v-if="a.weight_kg" style="color:var(--fm-s,#6B6356);font-size:11px;">{{ a.weight_kg }} kg</span>
          </label>
          <div v-if="!filteredAnimals.length" style="color:var(--fm-s,#6B6356);font-size:12px;padding:8px;">No animals match the filter.</div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3 mb-1">
        <h6 class="m-0 fw-bold" style="color:var(--fm-h,#F5F0E8);">Consignment ({{ form.items.length }})</h6>
        <button class="btn btn-sm btn-outline-warning" @click="addBlankItem"><i class="mdi mdi-plus me-1"></i>Add row</button>
      </div>
      <div v-if="!form.items.length" class="dn-empty">No animals on this note yet — pick from the list above or add a manual row.</div>
      <div v-else class="dn-items">
        <div v-for="(it, idx) in form.items" :key="'it-'+idx" class="dn-item">
          <div class="row g-1 align-items-center">
            <div class="col-md-2"><input v-model="it.ear_tag" class="dn-input w-100" placeholder="Ear tag" /></div>
            <div class="col-md-2"><input v-model="it.animal_class" class="dn-input w-100" placeholder="Class (Bull, etc.)" /></div>
            <div class="col-md-2"><input v-model="it.breed_type" class="dn-input w-100" placeholder="Breed" /></div>
            <div class="col-md-2"><input v-model.number="it.est_liveweight_kg" type="number" step="0.1" class="dn-input w-100" placeholder="kg" /></div>
            <div class="col-md-2">
              <select v-model="it.dispatch_condition" class="dn-input w-100">
                <option value="good">Good</option>
                <option value="fair">Fair</option>
                <option value="poor">Poor</option>
              </select>
            </div>
            <div class="col-md-2 d-flex gap-1">
              <input v-model="it.remarks" class="dn-input flex-fill" placeholder="Remarks" />
              <button class="btn btn-sm btn-outline-danger" @click="form.items.splice(idx,1)"><i class="mdi mdi-close"></i></button>
            </div>
          </div>
        </div>
      </div>

      <h6 class="fw-bold mt-3" style="color:var(--fm-h,#F5F0E8);">Dispatch checklist</h6>
      <div class="row g-1 mb-3">
        <div class="col-md-6" v-for="c in checklistKeys" :key="c.key">
          <label class="dn-chk"><input type="checkbox" v-model="form.checklist[c.key]" />{{ c.label }}</label>
        </div>
      </div>

      <h6 class="fw-bold" style="color:var(--fm-h,#F5F0E8);">Loading photos (up to 4)</h6>
      <div class="d-flex gap-2 flex-wrap mb-2">
        <div v-for="(p, idx) in form.existingPhotos" :key="'ep-'+p.id" class="dn-photo">
          <img :src="imgUrl(p.photo_url)" />
          <input v-model="p.caption" class="dn-input" placeholder="Caption" style="font-size:10px;padding:3px;" />
          <button class="btn btn-sm btn-outline-danger w-100" style="font-size:10px;padding:1px;" @click="removeExistingPhoto(p, idx)"><i class="mdi mdi-delete"></i></button>
        </div>
        <div v-for="(p, idx) in form.newPhotos" :key="'np-'+idx" class="dn-photo">
          <img :src="p.preview" />
          <input v-model="p.caption" class="dn-input" placeholder="Caption" style="font-size:10px;padding:3px;" />
          <button class="btn btn-sm btn-outline-danger w-100" style="font-size:10px;padding:1px;" @click="form.newPhotos.splice(idx,1)"><i class="mdi mdi-close"></i></button>
        </div>
        <label v-if="(form.existingPhotos.length + form.newPhotos.length) < 4" class="dn-photo-add">
          <i class="mdi mdi-camera-plus" style="font-size:24px;"></i>
          <span style="font-size:11px;margin-top:4px;">Add photo</span>
          <input type="file" accept="image/*" multiple style="display:none;" @change="onPhotos" />
        </label>
      </div>

      <div class="mb-3"><label class="dn-label">Notes</label><textarea v-model="form.notes" class="dn-input w-100" rows="2"></textarea></div>

      <button class="btn btn-warning w-100" @click="save" :disabled="!canSave || saving">
        <span v-if="saving"><span class="spinner-border spinner-border-sm me-1"></span>Saving...</span>
        <span v-else><i class="mdi mdi-content-save me-1"></i>{{ form.id ? 'Save changes' : 'Create delivery note' }}</span>
      </button>
      <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showForm=false">Cancel</button>
    </div>
  </div>

  <!-- Mark received modal -->
  <div v-if="showReceive" class="dn-overlay" @click.self="showReceive=false">
    <div class="dn-modal" style="max-width:780px;">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h5 class="m-0 fw-bold" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-check-decagram me-1"></i>Mark received</h5>
          <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:3px;" v-if="receive.note">
            {{ receive.note.document_ref }} · {{ receive.note.destination_name }} · {{ receive.items.length }} animal{{ receive.items.length===1?'':'s' }}
          </div>
        </div>
        <button class="btn-close btn-close-white" @click="showReceive=false"></button>
      </div>

      <div class="mb-3"><label class="dn-label">Received by name *</label><input v-model="receive.receivedByName" class="dn-input w-100" placeholder="e.g. James Mwangi (Slaughterhouse manager)" /></div>

      <h6 class="fw-bold mb-2" style="color:var(--fm-h,#F5F0E8);">Per-animal receipt</h6>
      <div class="d-flex gap-2 mb-2">
        <button class="btn btn-sm btn-outline-warning" @click="setAllReceipt('good')"><i class="mdi mdi-check me-1"></i>All Good</button>
        <button class="btn btn-sm btn-outline-warning" @click="setAllReceipt('fair')">All Fair</button>
      </div>

      <div class="dn-receive-list">
        <div v-for="it in receive.items" :key="'rcv-'+it.id" class="dn-receive-row">
          <div class="dn-receive-tag">
            <strong>{{ it.ear_tag }}</strong>
            <span style="color:var(--fm-m,#A09888);font-size:11px;">{{ it.animal_class || '' }}<span v-if="it.breed_type"> · {{ it.breed_type }}</span><span v-if="it.est_liveweight_kg"> · {{ it.est_liveweight_kg }} kg</span></span>
          </div>
          <div class="dn-receive-dispatch">
            <span class="dn-receive-label">Dispatch</span>
            <span class="dn-receive-pill" :class="'p-'+it.dispatch_condition">{{ (it.dispatch_condition||'').toUpperCase() }}</span>
          </div>
          <div class="dn-receive-receipt">
            <span class="dn-receive-label">Receipt</span>
            <select v-model="it.receipt_condition" class="dn-input">
              <option value="good">GOOD</option>
              <option value="fair">FAIR</option>
              <option value="poor">POOR</option>
            </select>
          </div>
          <div class="dn-receive-remarks">
            <input v-model="it.remarks" class="dn-input w-100" placeholder="Discrepancies / notes (optional)" />
          </div>
        </div>
      </div>

      <div v-if="receiveError" class="alert alert-danger py-2 mt-2" style="font-size:12px;">{{ receiveError }}</div>

      <button class="btn btn-success w-100 mt-3" @click="confirmReceive" :disabled="!receive.receivedByName || receiving">
        <span v-if="receiving"><span class="spinner-border spinner-border-sm me-1"></span>Confirming...</span>
        <span v-else><i class="mdi mdi-check me-1"></i>Confirm receipt</span>
      </button>
      <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showReceive=false">Cancel</button>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] .dn-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .dn-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .dn-card,html[data-theme="light"] .dn-modal,html[data-theme="light"] .dn-item{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .dn-input{background:#F7F5F2!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
</style>

<style scoped>
.dn-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.dn-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.dn-container{padding-top:80px;padding-bottom:60px;max-width:960px}
.dn-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:14px}
.dn-ref{font-family:monospace;color:#BFA164;font-weight:700;font-size:13px;background:rgba(191,161,100,.1);padding:3px 8px;border-radius:6px}
.dn-status{font-size:10px;font-weight:700;padding:3px 10px;border-radius:20px;text-transform:uppercase;letter-spacing:.4px}
.dn-status.st-draft{background:rgba(160,152,136,.16);color:#A09888}
.dn-status.st-dispatched{background:rgba(241,180,76,.16);color:#f1b44c}
.dn-status.st-received{background:rgba(80,200,120,.16);color:#50C878}
.dn-label{display:block;font-size:11px;color:var(--fm-s);text-transform:uppercase;letter-spacing:.3px;margin-bottom:4px;font-weight:600}
.dn-input{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:8px 10px;color:var(--fm-h,#F5F0E8);font-size:13px}
.dn-input:focus{outline:none;border-color:#BFA164}
.dn-pick-list{max-height:200px;overflow-y:auto;border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:6px;margin-top:6px}
.dn-pick-row{display:flex;align-items:center;gap:8px;padding:6px;font-size:13px;cursor:pointer;border-radius:6px}
.dn-pick-row:hover{background:var(--fm-bg2,#0F0F0F)}
.dn-empty{color:var(--fm-s,#6B6356);font-size:12px;padding:14px;text-align:center;border:1px dashed var(--fm-br,#2A2520);border-radius:8px}
.dn-item{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:8px;margin-bottom:6px}
.dn-chk{display:flex;align-items:center;gap:6px;font-size:12px;color:var(--fm-h,#F5F0E8);cursor:pointer;padding:4px}
.dn-photo{width:120px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;overflow:hidden;display:flex;flex-direction:column;gap:2px;padding-bottom:2px}
.dn-photo img{width:100%;height:90px;object-fit:cover}
.dn-photo-add{width:120px;height:135px;background:var(--fm-bg2,#0F0F0F);border:2px dashed var(--fm-br,#2A2520);border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;color:var(--fm-m,#A09888);cursor:pointer}
.dn-photo-add:hover{border-color:#BFA164;color:#BFA164}
.dn-overlay{position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:flex-start;justify-content:center;padding:30px 16px;z-index:2000;overflow-y:auto}
.dn-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:14px;padding:20px;max-width:920px;width:100%}
.dn-receive-list{display:flex;flex-direction:column;gap:6px;max-height:50vh;overflow-y:auto;padding-right:4px}
.dn-receive-row{display:grid;grid-template-columns:200px 100px 110px 1fr;gap:8px;align-items:center;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:8px 10px}
.dn-receive-tag{display:flex;flex-direction:column;line-height:1.3}
.dn-receive-dispatch,.dn-receive-receipt{display:flex;flex-direction:column;align-items:flex-start;gap:2px}
.dn-receive-label{font-size:9px;color:var(--fm-s);text-transform:uppercase;letter-spacing:.4px;font-weight:600}
.dn-receive-pill{font-size:10px;font-weight:700;padding:2px 8px;border-radius:10px;letter-spacing:.5px}
.dn-receive-pill.p-good{background:rgba(80,200,120,.16);color:#50C878}
.dn-receive-pill.p-fair{background:rgba(241,180,76,.16);color:#f1b44c}
.dn-receive-pill.p-poor{background:rgba(255,107,107,.16);color:#FF6B6B}
@media (max-width:700px){
  .dn-receive-row{grid-template-columns:1fr 1fr;gap:6px}
  .dn-receive-tag{grid-column:1 / -1}
  .dn-receive-remarks{grid-column:1 / -1}
}
</style>

<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";
export default {
  name: "DeliveryNotes",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true, saving:false,
    farm:{}, notes:[], animals:[],
    animalFilter:'',
    showForm:false,
    showReceive:false, receiving:false, receiveError:'',
    receive:{ note:null, receivedByName:'', items:[] },
    form:{
      id:0, destinationName:'', destinationAddress:'', deliveryDate:new Date().toISOString().slice(0,10),
      driverName:'', vehicleReg:'', dvsPermitNo:'', vetOfficerName:'', vetDvsPermitNo:'',
      notes:'', selectedAnimalIds:[], items:[],
      checklist:{ tags_match:true, permit:false, vet_clearance:false, watered_rested:true, halal:false, no_wounds:true, no_lameness:true, not_pregnant:false, vehicle_ok:true, cold_chain:false },
      existingPhotos:[], newPhotos:[]
    },
    checklistKeys:[
      {key:'tags_match', label:'All animals ear-tagged and matching delivery note'},
      {key:'no_wounds', label:'Animals free from visible wounds or lesions'},
      {key:'permit', label:'Movement permit attached (DVS)'},
      {key:'no_lameness', label:'Animals free from lameness'},
      {key:'vet_clearance', label:'County veterinary inspection clearance obtained'},
      {key:'not_pregnant', label:'Animals not pregnant / in milk (or N/A)'},
      {key:'watered_rested', label:'Animals watered and rested before loading'},
      {key:'vehicle_ok', label:'Vehicle condition inspected and approved'},
      {key:'halal', label:'Halal handling requirements observed (if applicable)'},
      {key:'cold_chain', label:'Cold chain / lairage arrangements confirmed at destination'}
    ]
  }},
  computed:{
    todayStr(){ return new Date().toISOString().split('T')[0]; },
    themePageStyle(){ return this.darkMode ? 'background:#0A0A0A;min-height:100vh;color:#F5F0E8;' : 'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'; },
    farmId(){ return this.$route.params.farmId; },
    filteredAnimals(){
      var q = (this.animalFilter || '').toLowerCase().trim();
      if (!q) return this.animals.slice(0, 100);
      return this.animals.filter(function(a){
        return ((a.tag_number||'').toLowerCase().indexOf(q) !== -1) || ((a.breed_name||'').toLowerCase().indexOf(q) !== -1);
      }).slice(0, 100);
    },
    canSave(){ return this.form.destinationName && this.form.deliveryDate && this.form.items.length > 0; }
  },
  mounted(){
    this._applyThemeOnce();var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    if(!sessionStorage.getItem('userId')){this.$router.push('/login');return}
    this.loadAll();
  },
  beforeUnmount(){ if(this.themeObserver){this.themeObserver.disconnect()} },
  methods:{
    _applyThemeOnce(){var current=document.documentElement.getAttribute('data-theme');var desired=(localStorage.getItem('flockr_theme')||current||'dark');if(current!==desired)document.documentElement.setAttribute('data-theme',desired);this.darkMode=desired!=='light';},
    imgUrl(u){if(!u)return'';if(String(u).indexOf('http')===0)return u;return uploads+String(u).replace(/^uploads\//,'');},
    humanize(s){ return (s||'').replace(/_/g,' ').replace(/\b\w/g, function(c){return c.toUpperCase()}); },
    fD(d){ if(!d)return''; try{ return new Date(d).toLocaleDateString(undefined,{day:'2-digit',month:'short',year:'numeric'}) }catch(e){return d} },
    statusLabel(s){ return ({draft:'Draft',dispatched:'Dispatched',received:'Received'})[s] || s; },
    async loadAll(){
      this.loading = true;
      try {
        var f = await executeJson({ function:'getFarmDetail', farmId:this.farmId }, flocker);
        if (f.data && f.data.success) this.farm = (f.data.data && f.data.data.farm) || {};
        var n = await executeJson({ function:'listDeliveryNotes', farmId:this.farmId }, flocker);
        if (n.data && n.data.success) this.notes = (n.data.data && n.data.data.deliveryNotes) || [];
        var a = await executeJson({ function:'getFarmAnimals', farmId:this.farmId }, flocker);
        if (a.data && a.data.success) this.animals = (a.data.data && a.data.data.animals) || [];
      } catch(e){ console.error(e); }
      this.loading = false;
    },
    openCreate(){
      this.form = { id:0, destinationName:'', destinationAddress:'', deliveryDate:new Date().toISOString().slice(0,10),
        driverName:'', vehicleReg:'', dvsPermitNo:'', vetOfficerName:'', vetDvsPermitNo:'', notes:'',
        selectedAnimalIds:[], items:[],
        checklist:{ tags_match:true, permit:false, vet_clearance:false, watered_rested:true, halal:false, no_wounds:true, no_lameness:true, not_pregnant:false, vehicle_ok:true, cold_chain:false },
        existingPhotos:[], newPhotos:[]
      };
      this.showForm = true;
    },
    async openEdit(n){
      try {
        var r = await executeJson({ function:'getDeliveryNote', deliveryNoteId:n.id }, flocker);
        if (r.data && r.data.success) {
          var dn = r.data.data.deliveryNote;
          var chk = {};
          try { chk = dn.checklist ? JSON.parse(dn.checklist) : {}; } catch(e){}
          this.form = {
            id: dn.id,
            destinationName: dn.destination_name || '',
            destinationAddress: dn.destination_address || '',
            deliveryDate: dn.delivery_date || new Date().toISOString().slice(0,10),
            driverName: dn.driver_name || '', vehicleReg: dn.vehicle_reg || '', dvsPermitNo: dn.dvs_permit_no || '',
            vetOfficerName: dn.vet_officer_name || '', vetDvsPermitNo: dn.vet_dvs_permit_no || '',
            notes: dn.notes || '',
            selectedAnimalIds: (dn.items || []).map(function(x){ return x.animal_id }).filter(Boolean),
            items: (dn.items || []).map(function(x){
              return { id:x.id, animal_id:x.animal_id || null, ear_tag:x.ear_tag, animal_class:x.animal_class || '',
                       breed_type:x.breed_type || '', est_liveweight_kg:x.est_liveweight_kg ? Number(x.est_liveweight_kg) : null,
                       dispatch_condition:x.dispatch_condition || 'good', remarks:x.remarks || '' };
            }),
            checklist: Object.assign({ tags_match:false, permit:false, vet_clearance:false, watered_rested:false, halal:false, no_wounds:false, no_lameness:false, not_pregnant:false, vehicle_ok:false, cold_chain:false }, chk),
            existingPhotos: dn.photos || [], newPhotos: []
          };
          this.showForm = true;
        }
      } catch(e){ alert('Could not load delivery note.') }
    },
    onAnimalToggled(a){
      // Build items from currently selected animal ids
      var existingByAnimal = {};
      this.form.items.forEach(function(it){ if (it.animal_id) existingByAnimal[it.animal_id] = it; });
      var self = this;
      this.form.items = this.form.selectedAnimalIds.map(function(animalId){
        if (existingByAnimal[animalId]) return existingByAnimal[animalId];
        var an = (self.animals || []).find(function(x){ return x.id === animalId });
        if (!an) return { animal_id:animalId, ear_tag:'', animal_class:'', breed_type:'', est_liveweight_kg:null, dispatch_condition:'good', remarks:'' };
        return {
          animal_id: an.id,
          ear_tag: an.tag_number || '',
          animal_class: (an.sex === 'male' ? 'Bull' : (an.sex === 'female' ? 'Cow' : '')),
          breed_type: an.breed_name || '',
          est_liveweight_kg: an.weight_kg ? Number(an.weight_kg) : null,
          dispatch_condition: 'good',
          remarks: ''
        };
      });
    },
    addBlankItem(){ this.form.items.push({ animal_id:null, ear_tag:'', animal_class:'', breed_type:'', est_liveweight_kg:null, dispatch_condition:'good', remarks:'' }); },
    onPhotos(e){
      var files = e.target.files; if (!files || !files.length) return;
      for (var i = 0; i < files.length; i++) {
        if ((this.form.existingPhotos.length + this.form.newPhotos.length) >= 4) break;
        var f = files[i];
        this.form.newPhotos.push({ file:f, caption:'', preview: URL.createObjectURL(f) });
      }
      e.target.value = '';
    },
    async removeExistingPhoto(p, idx){
      if (!confirm('Remove this photo?')) return;
      try {
        var r = await executeJson({ function:'deleteDeliveryNotePhoto', photoId: p.id }, flocker);
        if (r.data && r.data.success) this.form.existingPhotos.splice(idx, 1);
      } catch(e){ alert('Could not delete photo.') }
    },
    async save(){
      if (!this.canSave) return;
      this.saving = true;
      try {
        var fd = new FormData();
        fd.append('function', 'saveDeliveryNote');
        fd.append('farmId', this.farmId);
        fd.append('userId', sessionStorage.getItem('userId'));
        if (this.form.id) fd.append('deliveryNoteId', this.form.id);
        fd.append('destinationName', this.form.destinationName);
        fd.append('destinationAddress', this.form.destinationAddress || '');
        fd.append('deliveryDate', this.form.deliveryDate);
        fd.append('driverName', this.form.driverName || '');
        fd.append('vehicleReg', this.form.vehicleReg || '');
        fd.append('dvsPermitNo', this.form.dvsPermitNo || '');
        fd.append('vetOfficerName', this.form.vetOfficerName || '');
        fd.append('vetDvsPermitNo', this.form.vetDvsPermitNo || '');
        fd.append('notes', this.form.notes || '');
        fd.append('checklist', JSON.stringify(this.form.checklist));
        fd.append('items', JSON.stringify(this.form.items.map(function(it){
          return { animal_id:it.animal_id, ear_tag:it.ear_tag, animal_class:it.animal_class, breed_type:it.breed_type,
                   est_liveweight_kg:it.est_liveweight_kg, dispatch_condition:it.dispatch_condition, remarks:it.remarks };
        })));
        this.form.newPhotos.forEach(function(p, idx){
          fd.append('photo' + idx, p.file);
          if (p.caption) fd.append('caption_photo' + idx, p.caption);
        });
        var r = await execute(fd, flocker);
        if (r.data && r.data.success) {
          this.showForm = false;
          await this.loadAll();
        } else {
          alert((r.data && r.data.message) || 'Failed to save');
        }
      } catch(e){ alert('Network error'); }
      this.saving = false;
    },
    async dispatch(n){
      if (!confirm('Mark "' + n.document_ref + '" as dispatched?')) return;
      try {
        var r = await executeJson({ function:'markDeliveryNoteDispatched', deliveryNoteId:n.id, userId: sessionStorage.getItem('userId') }, flocker);
        if (r.data && r.data.success) await this.loadAll();
      } catch(e){ alert('Network error') }
    },
    async openReceive(n){
      this.receiveError = '';
      this.receive = { note: n, receivedByName: '', items: [] };
      try {
        var r = await executeJson({ function:'getDeliveryNote', deliveryNoteId:n.id }, flocker);
        if (r.data && r.data.success) {
          var dn = r.data.data.deliveryNote;
          this.receive.note = dn;
          this.receive.items = (dn.items || []).map(function(it){
            return {
              id: it.id,
              ear_tag: it.ear_tag,
              animal_class: it.animal_class,
              breed_type: it.breed_type,
              est_liveweight_kg: it.est_liveweight_kg,
              dispatch_condition: it.dispatch_condition,
              receipt_condition: (it.receipt_condition && it.receipt_condition !== 'pending') ? it.receipt_condition : 'good',
              remarks: it.remarks || ''
            };
          });
          this.showReceive = true;
        }
      } catch(e){ alert('Could not load.') }
    },
    setAllReceipt(cond){ this.receive.items.forEach(function(it){ it.receipt_condition = cond; }); },
    async confirmReceive(){
      if (!this.receive.receivedByName) { this.receiveError = 'Received-by name is required.'; return; }
      this.receiving = true;
      this.receiveError = '';
      try {
        var r = await executeJson({
          function: 'markDeliveryNoteReceived',
          deliveryNoteId: this.receive.note.id,
          receivedByName: this.receive.receivedByName,
          items: JSON.stringify(this.receive.items.map(function(it){ return { id:it.id, receipt_condition:it.receipt_condition, remarks:it.remarks }; }))
        }, flocker);
        if (r.data && r.data.success) {
          this.showReceive = false;
          await this.loadAll();
        } else {
          this.receiveError = (r.data && r.data.message) || 'Failed to mark received.';
        }
      } catch(e){ this.receiveError = 'Network error. Please retry.'; }
      this.receiving = false;
    },
    openPrint(n){
      var route = this.$router.resolve({ path: '/delivery-note/' + n.id + '/print' });
      window.open(route.href, '_blank');
    }
  }
};
</script>
